"use strict";
/**
 * Saves the given product ID to the local storage under the key "currentProductID".
 *
 * @param {string} productID - The ID of the product to be saved. If the productID is falsy, the function does nothing.
 */
const saveProductDataToStorage = (productID) => {
    if (!productID) return false;
    localStorage.setItem("currentProductID", productID);
    localStorage.setItem("productAfterFilter", productID);
};

module.exports = {
    /**
     * Attaches a click event listener to elements with the attribute "data-product-id"
     * and saves the product ID to storage when the element is clicked.
     * Utilizes jQuery for event handling and DOM manipulation.
     */
    saveDataToStorage: () => {
        $(document).on("click", "[data-product-id]", function () {
            const productID = $(this).data("product-id");
            saveProductDataToStorage(productID);
        });
    },

    /**
     * Checks if a product ID is stored in local storage and, if found, scrolls to the corresponding DOM element.
     * @returns {void}
     */
    checkLocalStorageItem: () => {
        $("body").on("viewItemListEventComplete", function () {
            const storedProduct = localStorage.getItem("currentProductID");
            if (storedProduct) {
                const DOMProduct = $(document).find(`[data-scroll-to=${storedProduct}]`);

                if (DOMProduct.length > 0) {
                    $("html, body").animate(
                        {
                            scrollTop: DOMProduct.offset().top - 160,
                        },
                        500
                    );
                    localStorage.removeItem("currentProductID");
                }
                if ($(".product-detail").length === 0) {
                    localStorage.removeItem("currentProductID");
                }
            }
        });
    },
};
